import React from 'react';
export function HonestQuestion() {
  return <section className="py-14 px-4 bg-white" data-id="element-119">
      <div className="max-w-2xl mx-auto text-center" data-id="element-120">
        <p className="text-2xl md:text-3xl font-bold text-gray-900 mb-6 leading-snug" data-id="element-121">
          Si querés vivir del detailing,
          <br data-id="element-122" />
          dejame hacerte una pregunta honesta.
        </p>

        <p className="md:text-xl text-gray-600 mb-3 text-[18px]" data-id="element-123">
          ¿Trabajás mucho pero no sabés cuánto cobrar ni cómo conseguir más
          clientes?
        </p>
        <p className="text-lg md:text-xl text-gray-500 mb-6" data-id="element-124">
          No porque no tengas ganas. No porque el trabajo no te salga bien.
        </p>

        <p className="font-bold text-[#1E1E54] text-xl md:text-2xl mb-6" data-id="element-125">
          Sino porque NADIE te enseñó el MÉTODO correcto de punta a punta.
        </p>

        <div className="bg-gray-900 text-white p-5 rounded-xl max-w-md mx-auto mb-6 text-left space-y-2.5 text-[15px] md:text-base font-medium" data-id="element-126">
          <p className="flex items-start gap-2.5" data-id="element-127">
            <span className="text-red-400 mt-0.5" data-id="element-128">✖</span>
            Buscar cómo hacer cada proceso desde cero.
          </p>
          <p className="flex items-start gap-2.5" data-id="element-129">
            <span className="text-red-400 mt-0.5" data-id="element-130">✖</span>
            No saber si el pad o producto que usás es el correcto.
          </p>
          <p className="flex items-start gap-2.5" data-id="element-131">
            <span className="text-red-400 mt-0.5" data-id="element-132">✖</span>
            Dudar si el precio que cobrás es el justo.
          </p>
          <p className="flex items-start gap-2.5" data-id="element-133">
            <span className="text-red-400 mt-0.5" data-id="element-134">✖</span>
            No poder mostrar tu trabajo para conseguir el siguiente cliente.
          </p>
        </div>

        <p className="text-xl md:text-2xl font-bold text-[#EAB308] mt-2" data-id="element-135">
          Vivir del detailing no debería sentirse así.
        </p>
      </div>
    </section>;
}